import axios from "axios";
import Cookies from "universal-cookie";
import { serverLink } from "../constants/serverlinks";

const cookies = new Cookies();

const instance = axios.create({
  baseURL: `${serverLink}/api`,
});

instance.interceptors.request.use(
  async (config) => {
    const token = await cookies.get("token");
    if (token) {
      config.headers.Authorization = `token ${token}`;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

export default instance;
